import { portalApi } from '../../../../store/generated/portal/employee-records';

export const EmployeeRecordApiTags = {
  EmployeeRecords: 'EmployeeRecords',
  EmployeeRecord: 'EmployeeRecord',
};

const taggedApi = portalApi.enhanceEndpoints({
  addTagTypes: Object.values(EmployeeRecordApiTags),
});

export const employeeRecApi = taggedApi.enhanceEndpoints({
  endpoints: {
    apiPortalV1EmployeeRecordsDestroy: {
      invalidatesTags: (result, error, arg) => [
        { type: EmployeeRecordApiTags.EmployeeRecords, id: arg.id },
        { type: EmployeeRecordApiTags.EmployeeRecords }, // general list
      ],
    },
    apiPortalV1EmployeeRecordsCreate: {
      invalidatesTags: [{ type: EmployeeRecordApiTags.EmployeeRecords }],
    },
    apiPortalV1EmployeeRecordsPartialUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: EmployeeRecordApiTags.EmployeeRecords, id: arg.id },
        { type: EmployeeRecordApiTags.EmployeeRecords },
      ],
    },
    apiPortalV1EmployeeRecordsUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: EmployeeRecordApiTags.EmployeeRecords, id: arg.id },
        { type: EmployeeRecordApiTags.EmployeeRecords },
      ],
    },
    apiPortalV1EmployeeRecordsRetrieve: {
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: EmployeeRecordApiTags.EmployeeRecords, id: arg.id },
              { type: EmployeeRecordApiTags.EmployeeRecords }, // general
            ]
          : [{ type: EmployeeRecordApiTags.EmployeeRecords }],
    },
    apiPortalV1EmployeeRecordsList: {
      providesTags: [{ type: EmployeeRecordApiTags.EmployeeRecords }],
    },
    apiPortalV1EmployeeRecordsByPeriodAndValueRetrieve: {
      providesTags: [{ type: EmployeeRecordApiTags.EmployeeRecords }],
    },
  },
});
